const sameArgs = (newArgs, lastArgs) => {
  if (newArgs.length !== lastArgs.length) {
    return false;
  }

  for (let i = 0; i < newArgs.length; i++) {
    if (newArgs[i] !== lastArgs[i]) {
      return false;
    }
  }

  return true;
};

const memoizeLast = (fn) => {
  let cache = null;

  return (...args) => {
    if (cache && sameArgs(args, cache.args)) {
      return cache.result;
    }

    const result = fn(...args);
    cache = {
      result,
      args,
    };

    return result;
  };
};

export default memoizeLast;
